import { Navigate, Outlet } from "react-router-dom";
import { useProfile } from "../lib/profile";
import { CenteredSpinner } from "../design/ui";

export function RequireAuth({ requireAdmin = false }: { requireAdmin?: boolean }) {
  const { status, profile, error } = useProfile();

  if (status === "checking") {
    return <CenteredSpinner label="Checking session" />;
  }
  if (status === "anonymous" || status === "error") {
    return <Navigate to="/login" replace state={error ? { authError: error } : undefined} />;
  }
  if (requireAdmin && profile?.role !== "admin") {
    return <Navigate to="/home" replace />;
  }
  return <Outlet />;
}
